<template>
    <b-row>
        <b-col cols="12" class="h4 mb-3">
            {{ $t('gracias.fecha') }} {{ sesion_fecha }}
        </b-col>
        <b-col cols="12">
            <div class="lightgray-content p-2 small-font mb-4 pb-2 border-bottom d-flex" :key="index">
                <div class="d-flex flex-column flex-sm-row w-100 justify-content-between align-items-center container-fluid position-relative p-1">
                    <div class="w-100">
                        <strong class="mb-2 red text-uppercase">
                            {{ manager.termino_entrada }}
                            {{ index + 1 }}
                        </strong>
                        <div>
                            <span class="h3 mb-3 text-italicy">
                                {{ entrada.asiento?.zona?.nombre }}
                            </span>
                        </div>
                        <template v-if="entrada.asiento?.fila && entrada.asiento?.numero">
                            <div>
                                <label class="mb-1 text-bold">Fila:</label>
                                {{ entrada.asiento.fila }}
                            </div>
                            <div>
                                <label class="mb-1 text-bold">Butaca:</label>
                                {{ entrada.asiento.numero }}
                            </div>
                        </template>
                    </div>
                    <div class="h-100 w-100">
                        <div class="d-flex flex-column align-items-start align-items-sm-end justify-content-between h-100">
                            <template v-if="!entrada.descuento_id">
                                <div class="d-flex align-items-end h-100">
                                    <label>{{ $t("gracias.precio") }}</label>
                                    <span class="h2 ml-2">
                                        {{ formatearPrecio(precioFinal) }}
                                    </span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="d-flex align-items-end align-items-sm-center h-100">
                                    <label>{{ $t("gracias.precio") }}</label>
                                    <span class="h2 ml-2">
                                        {{ formatearPrecio(precioFinalConDescuento) }}
                                    </span>
                                    <span class="h4 ml-1">
                                        (<del>
                                            {{ formatearPrecio(precioFinal) }}
                                        </del>)
                                    </span>
                                </div>
                            </template>
                            <div>
                                <p class="mb-0 small">
                                    {{ $t('eventos_sga.precio_incluye', { precio: formatearPrecio(entrada.importe), gastos: formatearPrecio(resumen.gastos_gestion_individual) }) }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script setup>
    import { computed } from 'vue';
    import store from '@/store';
    import { useFilters } from '@/composables/front/formatters/useFilters';
    
    const props = defineProps({
        entrada: {
            required: true,
            type: Object
        },
        sesion_fecha: {
            required: true,
            type: String
        },
        index: {
            required: true,
            type: Number    
        },
        resumen: {
            required: true,
            type: Object
        }
    });
    
    const { formatearPrecio } = useFilters();
    
    const manager = computed(() => store.getters.getFooter);
    
    const precioFinal = computed(() => {
        const importe = parseFloat(props.entrada.importe || 0);
        const gastos = parseFloat(props.resumen.gastos_gestion_individual || 0);
        return importe + gastos;    
    });
    
    const precioFinalConDescuento = computed(() => {
        const importeConDescuento = parseFloat(props.entrada.importe_con_descuento || 0);
        const gastos = parseFloat(props.resumen.gastos_gestion_individual || 0);
        return importeConDescuento + gastos;
    });
    </script>